import {  s3sClient  } from "./index";

export const getUsers = (token) => s3sClient.get(`azure_usermanagment/user/users`, { headers: {"Authorization" : `Bearer ${token}`} } );
export const getRoles = (token) => s3sClient.get(`azure_usermanagment/user/roles`, { headers: {"Authorization" : `Bearer ${token}`} } );
export const assignRole = (payload, token) => s3sClient.post(`azure_usermanagment/role/add`, payload,  { headers: {"Authorization" : `Bearer ${token}`} } );

export const addFacility = (facility, token) => s3sClient.post(`azure_usermanagment/facility/add?facility=${facility}`, {},  { headers: {"Authorization" : `Bearer ${token}`} } );

export const deleteFacility = (facility, token) => 
  s3sClient.delete(`azure_usermanagment/facility/delete?facility=${facility}`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });